import React, { useRef, useState } from "react";

import { SaveButton, useNotify, useRedirect } from "react-admin";

import { logError } from "../../../utils/appUtils";
import { doUpdateReloadYardAccount } from "./customerUtils";

export const ValidateSaveButton = ({ record, ...props }) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const [isSaving, setIsSaving] = useState(false);
  const capturedRef = useRef({});

  const transform = (data) => {
    data = { ...data };
    capturedRef.current.description =
      data.reloadYardAccounts?.items?.[0]?.description;
    capturedRef.current.acl = data.reloadYardAccounts?.items?.[0]?.acl;
    debugger;

    data.email = data.email.toLowerCase();

    delete data.accountId;
    delete data.reloadYardAccounts;
    delete data.description;

    return data;
  };

  const onSuccess = async ({ data }) => {
    debugger;
    try {
      const reloadYardAccount = {
        ...data.reloadYardAccounts.items[0],
        acl: capturedRef.current.acl,
        description: capturedRef.current.description,
      };
      await doUpdateReloadYardAccount(reloadYardAccount);

      notify(`User updated successfully.`);
      redirect("/customers");
    } catch (error) {
      logError(
        "managerApp:customers:ValidateSaveButton:onSuccess",
        error,
        notify,
      );
    } finally {
      setIsSaving(false);
    }
  };

  const onFailure = (error) => {
    setIsSaving(false);
    logError(
      "managerApp:customers:ValidateSaveButton:onFailure",
      error,
      notify,
    );
  };

  return (
    <SaveButton
      {...props}
      submitOnEnter={false}
      undoable={false}
      disabled={props.pristine}
      saving={isSaving}
      transform={transform}
      onSuccess={onSuccess}
      onFailure={onFailure}
    />
  );
};
